import { CandidateNotesTab } from 'services/candidate/components/CandidateReportDrawer/CandidateNotesTab';

type CandidateProfileAnalysisNotesProps = {
  candidateId: string | null;
};

export const CandidateProfileAnalysisNotes: React.FC<
  CandidateProfileAnalysisNotesProps
> = ({ candidateId }) => {
  if (!candidateId) {
    return null;
  }

  return <CandidateNotesTab candidateId={candidateId} />;
};
